<template>
  <vxe-modal title="同步问题明细确认" width="80%" height="80%" v-model="formVisible" destory-on-close @show="showModal">
    <el-row :gutter="20">
      <el-col :span="4">
        <el-form>
          <div class="TechnicalTesting">
            <YK-divider>技术测试</YK-divider>
            <el-form-item label="郑济昌" prop="zjc">
              <el-input
                v-model="form.Technical.zjc"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
            <el-form-item label="刘坤辉" prop="lkh">
              <el-input
                v-model="form.Technical.lkh"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </div>
          <div class="BusinessTest">
            <YK-divider>业务测试</YK-divider>
            <el-form-item label="张光胜" prop="zgs">
              <el-input
                v-model="form.Business.zgs"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
            <el-form-item label="刘坤辉" prop="lkh">
              <el-input
                v-model="form.Business.lkh"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
            <el-form-item label="李季" prop="lj">
              <el-input
                v-model="form.Business.lj"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
              ></el-input>
              <template slot="error" slot-scope="slot">
                <errorTooltip :content="slot.error"></errorTooltip>
              </template>
            </el-form-item>
          </div>
        </el-form>
      </el-col>
      <el-col :span="20">
        <vxe-table
          border
          show-overflow
          ref="xTable"
          align="center"
          :height="tableHeight"
          :data="tableData"
          :column-config="{ minWidth: '80px' }"
          :mouse-config="{ area: true, extension: true }"
          :edit-rules="validRules"
          :edit-config="{
            trigger: 'dblclick',
            mode: 'cell',
            activeMethod: activeMethod
          }"
          :keyboard-config="{
            isArrow: true,
            isEnter: true,
            isTab: true,
            isClip: true,
            enterToTab: true,
            isEdit: true,
            editMethod: editMethod
          }"
          :menu-config="{ body: { options: bodyMenus }, visibleMethod }"
          @menu-click="contextMenuClickEvent"
          @cell-dblclick="cellDblclick"
        >
          <vxe-column type="seq" width="40px" fixed="left"></vxe-column>
          <vxe-column field="delete" title="删除" fixed="left" width="50" align="center">
            <template slot-scope="scope">
              <i
                id="vxeDelete"
                @click="removeRowForTable(scope.row, $refs.xTable, $data)"
                class="el-icon-delete-solid"
              ></i>
            </template>
          </vxe-column>
          <!-- 待处理 -->
          <!-- <vxe-column
        field="todo"
        title="版本"
        :filters="[{ data: null }]"
        :filter-render="{ name: 'FilterInput' }"
      ></vxe-column> -->
          <vxe-column min-width="100px" field="companys" title="登记单位"></vxe-column>
          <vxe-column min-width="100px" field="groupName" title="模块"></vxe-column>
          <vxe-column min-width="120px" field="vuePath" title="菜单"></vxe-column>
          <vxe-column min-width="240px" field="content" title="问题内容">
            <!-- <template #default="{ row }">
          <div style="text-align: left" v-html="formatContent(row)"></div>
        </template> -->
          </vxe-column>
          <!-- <vxe-column
        min-width="120px"
        field="comment"
        title="说明"
        :edit-render="{ name: '$input' }"
      ></vxe-column> -->
          <vxe-column
            field="type"
            title="类型"
            :edit-render="{ name: '$input', attrs: { disabled: true } }"
          ></vxe-column>
          <vxe-column field="createtor" title="提出人"></vxe-column>
          <vxe-column field="research" title="调研人"></vxe-column>
          <vxe-column field="createDate" title="提出日期" formatter="formatDate"></vxe-column> </vxe-table
      ></el-col>
    </el-row>
    <div class="buttonContainer">
      <el-button size="mini" @click="close"> 取消 </el-button>
      <el-button size="mini" type="primary" @click="confirm"> 确认 </el-button>
    </div>
    <DetailUpdateModal ref="DetailUpdateModal" :isDisabled="true" :updateRow="seeRow" :isSyncDetail="true" />
  </vxe-modal>
</template>

<script>
import DetailUpdateModal from './DetailUpdateModal'
export default {
  name: 'SyncToCooperationDetail',
  props: {
    tableList: {
      type: Array
    }
  },
  components: { DetailUpdateModal },
  data() {
    return {
      id: 0,
      tableData: [],
      // 需要提交的表单数据
      form: {
        Technical: {
          lkh: 0,
          zjc: 1
        },
        Business: {
          lkh: 0,
          zgs: 0,
          lj: 0
          // smq: 0
        }
      },
      formVisible: false,
      // 明细验证规则
      validRules: {
        type: [{ required: true, message: '请选择类型', trigger: 'change' }]
      },
      // table快捷键
      bodyMenus: [
        [
          {
            code: 'type',
            name: '完善'
          },
          {
            code: 'type',
            name: '错误'
          },
          {
            code: 'type',
            name: '新增'
          }
        ]
      ],
      seeRow: {} // 需要查看的行
    }
  },
  methods: {
    // 根据缩写获取中文名
    GetNameDict(shotName) {
      switch (shotName) {
        case 'zjc':
          return '郑济昌'
        case 'lkh':
          return '刘坤辉'
        case 'zgs':
          return '张光胜'
        case 'lj':
          return '李季'
      }
    },
    // 双击事件
    cellDblclick({ row, column }) {
      // const re = new RegExp(/!#!/g)
      // let str = row.content + ''
      if (column.property === 'content') {
        this.seeRow = { requirementDesc: row.content }
        this.$refs.DetailUpdateModal.formVisible = true
      }
    },
    // 取消事件
    close() {
      this.formVisible = false
    },
    // 确认事件
    confirm() {
      this.save()
    },
    // 开启窗口时
    showModal() {
      this.tableData = this.tableList
      this.form = {
        Technical: {
          zjc: 1,
          lkh: 1
        },
        Business: {
          lkh: 0,
          zgs: 0,
          lj: 0
        }
      }
    },
    // 格式化问题内容
    // formatContent(row) {
    //   if (row.content) {
    //     let list = []
    //     let HTMLStr = ``
    //     list = row.content.split('!#!')
    //     for (let item of list) {
    //       HTMLStr = HTMLStr + item + `<br/>`
    //     }
    //     return HTMLStr
    //   } else {
    //     return ''
    //   }
    // },
    // cell激活控制
    activeMethod({ column }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // 保存数据
    async save() {
      // 判断工作量是否有设置
      if (
        Object.values(this.form.Technical).filter(item => item > 0).length === 0 ||
        Object.values(this.form.Business).filter(item => item > 0).length === 0
      ) {
        this.$message.error('技术测试或业务测试的工作量之和最少要为1!')
        return
      }
      this.validEvent().then(async result => {
        if (result) {
          let tableData = this.$refs.xTable.getTableData().fullData
          tableData = this.removeArrayNull(tableData)
          // 提取所有明细中的附件并合并
          let attachment = []
          tableData.forEach(item => {
            if (item.attachments && Array.isArray(item.attachments)) {
              attachment = [...attachment, ...item.attachments]
            }
          })

          const { data: res } = await this.$http.post(
            '/Common/YKCase/synchronize',
            {
              Technical: Object.keys(this.form.Technical)
                .filter(key => this.form.Technical[key] > 0)
                .map(key => {
                  return { name: this.GetNameDict(key), ratio: this.form.Technical[key] }
                }),
              Business: Object.keys(this.form.Business)
                .filter(key => this.form.Business[key] > 0)
                .map(key => {
                  return { name: this.GetNameDict(key), ratio: this.form.Business[key] }
                }),
              tableData,
              attachment
            },
            {
              headers: {
                cooperation: true
              }
            }
          )
          if (!res.isSuccess) {
            this.$message.error(res.errorMessage)
            return false
          }
          this.$message.success('同步成功!请到协作系统中查看')
          this.$emit('successBack')
        }
      })
    },
    // 验证table数据
    async validEvent() {
      let flag = true
      this.errIndex = []
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          flag = false
        }
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 右键控制菜单方法
    visibleMethod({ options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          if (column) {
            switch (column.property) {
              case 'type':
                item.visible = true
                break
              default:
                item.visible = false
                break
            }
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    contextMenuClickEvent({ menu }) {
      const areas = this.$refs.xTable.getCellAreas()
      areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === 'type') {
              row[col.property] = menu.name
            }
          }
        }
      })
    }
  },
  computed: {
    tableHeight() {
      const titleHeight = 26
      const modalPadding = 25
      const buttonHeight = 40
      let height = Number(this.$store.state.clientHeight) * 0.8 - titleHeight - buttonHeight - modalPadding
      return height + 'px'
    }
  }
}
</script>
<style lang="less" scoped>
.buttonContainer {
  float: right;
  height: 40px;
  box-sizing: border-box;
  padding-top: 10px;
}
#vxeDelete {
  color: red;
}
</style>
